import React from "react";

const LogoGreen = ({
  width = 63,
  height = 64,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 63 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 28.3751V24.7193C22.7161 25.3739 21.2875 25.7203 19.8288 25.7182C14.7532 25.7182 10.6338 21.5988 10.6338 16.5232C10.6338 12.3448 13.4254 8.81453 17.244 7.69689L14.7504 5.75751C14.5359 5.59061 14.2718 5.5 14 5.5C13.7282 5.5 13.4641 5.59061 13.2496 5.75751L3.47178 13.3622C3.32477 13.4765 3.20584 13.623 3.12408 13.7903C3.04231 13.9577 2.99987 14.1415 3 14.3277V27.1733C3 27.4974 3.12877 27.8083 3.35798 28.0375C3.58719 28.2667 3.89807 28.3955 4.22222 28.3955H23.7778C23.8528 28.3955 23.9272 28.3886 24 28.3751Z"
        fill="#A0F8CD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3593 24.207L28.3871 24.2342L29.7853 22.8041L26.1756 19.275C26.5866 18.3792 26.8028 17.3994 26.8013 16.4007C26.8013 12.5915 23.7098 9.5 19.9007 9.5C16.0915 9.5 13 12.5915 13 16.4007C13 20.2098 16.0915 23.3013 19.9007 23.3013C21.4664 23.3036 22.9858 22.7709 24.2075 21.7916L27.4906 25.0756L28.3593 24.207ZM23.5757 16.5781C23.5757 18.5111 22.0087 20.0781 20.0757 20.0781C18.1427 20.0781 16.5757 18.5111 16.5757 16.5781C16.5757 14.6451 18.1427 13.0781 20.0757 13.0781C22.0087 13.0781 23.5757 14.6451 23.5757 16.5781Z"
        fill="#A0F8CD"
      />
    </svg>
  );
};

export default LogoGreen;
